import React, { FC, useContext } from "react";
import { AppContext } from "../../app/store";
import { getLinkToMedicare } from "../../helpers/CONSTANTS";
import { AnalyticsActionType } from "../../app/contexts/Analytics/types";

export const LinkExtraHelp: FC = ({ children }) => {
  const {
    state: { language },
    dispatch,
  } = useContext(AppContext);
  const href = getLinkToMedicare({
    language,
    mgovUrlKey: "prescriptionCostHelp",
  });
  const text = String(children);
  return (
    <a
      href={href}
      onClick={() => {
        dispatch({
          type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
          settings: {
            linkText: text,
            linkUrl: href,
            text: text,
          },
        });
      }}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};
